import { isSameHour, setHours, setMinutes, setSeconds } from "date-fns";

export function isDateWithTime(date: Date) {

  return !isSameHour(date, setSeconds(setMinutes(setHours(date, 0), 0), 0));
}